import React, { createContext, useState, useEffect } from "react"
import { getUser, saveUser } from "../utils/userContactInfo"

export const ContactContext = createContext(null)

export default ({ children }) => {
  const [customerName, setCustomerNameState] = useState("")
  const [customerPhone, setCustomerPhoneState] = useState("")
  const [customerEmail, setCustomerEmailState] = useState("")

  const setCustomerName = val => {
    saveUser({
      name: val,
      phone: customerPhone,
      email: customerEmail,
    })
    setCustomerNameState(val)
  }

  const setCustomerPhone = val => {
    saveUser({
      name: customerName,
      phone: val,
      email: customerEmail,
    })
    setCustomerPhoneState(val)
  }

  const setCustomerEmail = val => {
    saveUser({
      name: customerName,
      phone: customerPhone,
      email: val,
    })
    setCustomerEmailState(val)
  }

  const getUserInfo = () => {
    const user = getUser()
    setCustomerNameState(user.name ? user.name : "")
    setCustomerPhoneState(user.phone ? user.phone : "")
    setCustomerEmailState(user.email ? user.email : "")
  }

  useEffect(() => {
    getUserInfo()
  }, [])

  return (
    <ContactContext.Provider
      value={{
        customerName,
        customerPhone,
        customerEmail,
        setCustomerName,
        setCustomerPhone,
        setCustomerEmail,
      }}
    >
      {children}
    </ContactContext.Provider>
  )
}
